import { css } from '@emotion/react';
import { noop } from 'lodash';
import { type HTMLProps, type MemoExoticComponent, memo } from 'react';

import { RadioButtonGroupContextProvider } from '../radio/contexts/RadioButtonGroup.context';
import { RadioButton } from './radio-button/RadioButton';

export type RadioButtonGroupProps = Omit<
  HTMLProps<HTMLDivElement>,
  'ref' | 'value' | 'onChange'
> & {
  /** Selected value. */
  value?: string;
  /** On change function. */
  onChange?: (newValue: string) => void;
};

export const RadioButtonGroupBase = ({
  value = null,
  onChange = noop,
  children = null,
  ...props
}: RadioButtonGroupProps) => (
  <RadioButtonGroupContextProvider value={value} onChange={onChange}>
    <div
      {...props}
      css={css`
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
      `}
    >
      {children}
    </div>
  </RadioButtonGroupContextProvider>
);

RadioButtonGroupBase.displayName = 'RadioButtonGroup';

export const RadioButtonGroup: MemoExoticComponent<typeof RadioButtonGroupBase> & {
  RadioButton?: typeof RadioButton;
} = memo(RadioButtonGroupBase);

RadioButtonGroup.RadioButton = RadioButton;
